exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".alert-dismissible[data-v-17c169d3] {\n  padding-right: 1.25rem;\n  padding-top: 2.5rem;\n}", ""]);

